import { type ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileStickyBar from "./MobileStickyBar";
import WhatsAppStickyButton from "./WhatsAppStickyButton";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col pt-[72px] md:pt-[82px]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileStickyBar />
      <WhatsAppStickyButton />
    </div>
  );
}